import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useCallback, useRef, useState, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { Button } from '../Button/index';
import { SwatchPicker, Swatch, } from '../SwatchPicker';
import { ProductCellOverlay, } from './ProductCellOverlay';
const artistNameStyles = css `
  ${theme.typeStyles.bodySmallStyles}
  overflow-wrap: break-word;
`;
const colorwayContainerStyles = css `
  padding-top: ${theme.spacing.x4};
`;
const imageContainerStyles = css `
  align-items: center;
  background-color: ${theme.colors.gray700};
  display: flex;
  flex-flow: column;
  flex: 1 1 0;
  height: 100%;
  position: absolute;
  width: 100%;
`;
const imageStyles = css `
  ${styleUtils.transition('opacity')}
  display: block;
  height: 100%;
  width: 100%;
  position: absolute;
`;
const overlayButtonContainerStyles = css `
  padding-bottom: ${theme.spacing.base};
  width: ${styleUtils.rem(180)};
`;
const productContainerStyles = css `
  color: ${theme.colors.gray700};
  max-width: 100%;
  position: relative;
`;
const productNameStyles = css `
  ${theme.typeStyles.bodyMediumStyles}
  padding-top: ${theme.spacing.x2};
  ${theme.typeStyles.bodyBoldStyles}
  overflow-wrap: break-word;
`;
const ProductCellTertiary = ({ artistName, initialImageAspectRatio = 1, onColorChange = () => { }, overlayPrimaryButtonOnClick, overlayPrimaryButtonText = 'Select Design', overlaySecondaryButtonOnClick, overlaySecondaryButtonText = 'View Demo', productColorways, productName, selectedColorway, swatchPickerSize = 'small', windowContexts, }) => {
    const containerRef = useRef(null);
    const imageRef = useRef(null);
    const [isImageLoaded, setIsImageLoaded,] = useState(false);
    const [ratio, setRatio,] = useState(initialImageAspectRatio);
    const onImageLoaded = (useCallback(() => {
        var _a, _b;
        const originalImageHeight = ((_a = imageRef.current) === null || _a === void 0 ? void 0 : _a.naturalHeight) || 0;
        const originalImageWidth = ((_b = imageRef.current) === null || _b === void 0 ? void 0 : _b.naturalWidth) || 0;
        setRatio(originalImageWidth / originalImageHeight);
        setIsImageLoaded(true);
    }, [
        imageRef,
        setIsImageLoaded,
    ]));
    return (_jsxs("div", { children: [_jsxs("div", Object.assign({ css: css `
          ${productContainerStyles}
          padding-bottom: ${(1 / ratio) * 100}%;
        `, ref: containerRef }, { children: [_jsx("div", Object.assign({ css: imageContainerStyles }, { children: _jsx("img", { alt: selectedColorway === null || selectedColorway === void 0 ? void 0 : selectedColorway.alt, css: css `
                ${imageStyles}
                opacity: ${isImageLoaded ? 1 : 0};
              `, onLoad: onImageLoaded, ref: imageRef, src: selectedColorway === null || selectedColorway === void 0 ? void 0 : selectedColorway.productImageUrl }) })), _jsxs(ProductCellOverlay, Object.assign({ windowContexts: windowContexts }, { children: [_jsx("div", Object.assign({ css: overlayButtonContainerStyles }, { children: _jsx(Button, { expand: true, onClick: overlayPrimaryButtonOnClick, text: overlayPrimaryButtonText, type: "primary" }) })), _jsx("div", Object.assign({ css: overlayButtonContainerStyles }, { children: _jsx(Button, { expand: true, onClick: overlaySecondaryButtonOnClick, text: overlaySecondaryButtonText, type: "secondary" }) }))] }))] })), _jsx("div", Object.assign({ css: colorwayContainerStyles }, { children: _jsx(SwatchPicker, Object.assign({ name: `${artistName}${productName}`, onChange: onColorChange, selectionType: "single", size: swatchPickerSize, value: selectedColorway === null || selectedColorway === void 0 ? void 0 : selectedColorway.inputValue }, { children: productColorways === null || productColorways === void 0 ? void 0 : productColorways.map(({ colorValue, inputValue, name, }) => (_jsx(Swatch, { color: colorValue, displayName: name, value: inputValue }, inputValue))) })) })), _jsx("div", Object.assign({ css: productNameStyles }, { children: productName })), _jsxs("div", Object.assign({ css: artistNameStyles }, { children: ["by", ' ', artistName] }))] }));
};
const MemoizedProductCellTertiary = memo(ProductCellTertiary);
export { MemoizedProductCellTertiary as ProductCellTertiary };
// MC-1068 Temporary hack for Storybook.
export default ProductCellTertiary;
